module.exports = {
  APILOCALURL: "http://localhost:5050/api/",
  APISERVERURL: "http://localhost:5050/api/",
  APIACTIVEURL: "https://rextech.azurewebsites.net/api/",

  REGISTER: "auth/register",
  LOGIN: "auth/login",
  FORGOTPASSWORD: "auth/forgotpassword",
  RESETPASSWORD: "auth/resetpassword",

  GETALLUSERS:"user/getall",
  GETUSERPROFILE:"user/profile",
  UPDATEUSERPROFILE:"user/profile",
  CREATEUSER:"user",
  DELETEUSER:"user",
  UPDATEUSER:"user",
 

  GETALLRECYCLEITEMS:"recycleitem/getall",
  CREATERECYCLEITEM:"recycleitem",
  UPDATERECYCLEITEM:"recycleitem",
  DELETERECYCLEITEM:"recycleitem",

 GETALLPICKUPITEMS:"pickupitem/getall",
 CREATEPICKUPITEM:"pickupitem",
 UPDATEPICKUPITEM:"pickupitem",
 DELETEPICKUPITEM:"pickupitem",

  GETALLBRANCHES:"branch/getall",
  CREATEBRANCH:"branch",
  UPDATEBRANCH:"branch",
  DELETEBRANCH:"branch",

  GETALLCOMPANIES:"company/getall",
  GETCOMPANYBYUSERID:"company/getbyuser",
  CREATECOMPANY:"company/create",
  UPDATECOMPANY:"company",
  DELETECOMPANY:"company",



  GETALLREQUESTS:"request/getall",
  GETREQUESTBYUSERID: "request/getbyuser",
  CREATEREQUEST:"request",
  UPDATEREQUEST:"request",
  UPDATESTATUS:"request/updatestatus",
  UPDATECOLLECTOR:"request/assigncollector",
  DELETEREQUEST:"request",
  ADDITEM:"request",
  REMOVEITEM:"request",
  GETREQUESTREPORT: "request/report",
}


